
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { wellFormedRegex } from '../ConversationValidator'
import { isSafeKey } from '@/utils/string'

@Component<ReferenceInput>({
    model: {
        prop: 'value',
        event: 'change',
    },
})
export default class ReferenceInput extends Vue {
    @Prop(String) public value!: string

    public internalValue = ''

    public mounted() {
        this.internalValue = this.value
    }

    public onKeyDown(evt) {
        if (!isSafeKey(evt.key)) {
            evt.preventDefault()
        }
    }

    public handleInput(event: Event) {
        const el = event.target as HTMLInputElement
        const valid = new RegExp(wellFormedRegex).test(el.value)
        const newValue = valid ? el.value : this.value

        this.internalValue = newValue
        this.$emit('change', newValue)
    }

    public handleSubmit(event: Event) {
        const el = event.target as HTMLInputElement
        el.blur()
        this.$emit('submit', this.internalValue)
    }
}
